import { sortBy, toString } from 'lodash';
import url from 'url';

import { ACTION_PREFIX, CARRIER } from '../constants';
import { INSURANCE_TYPES } from '../../constants';
import carriersSelector from './carriersSelector';

export const REQUEST_CARRIERS = `${ACTION_PREFIX}/REQUEST_CARRIERS`;
export const REQUEST_CARRIERS_SUCCEEDED = `${ACTION_PREFIX}/REQUEST_CARRIERS_SUCCEEDED`;
export const REQUEST_CARRIERS_FAILED = `${ACTION_PREFIX}/REQUEST_CARRIERS_FAILED`;

const geisingerHealthPlanDirectoryId = '572';
const apiUrl = url.parse(process.env.API_HOST || '');

function requestCarriers(insuranceType) {
    return {
        type: REQUEST_CARRIERS,
        payload: {
            insuranceType,
        },
    };
}

function parseCarriers(carriers, insuranceType, directoryId) {
    const parsedCarriers = carriers.map(carrier => ({
        id: toString(carrier[0]),
        name: carrier[1],
    }));

    if (insuranceType === INSURANCE_TYPES.DENTAL) {
        return parsedCarriers;
    }

    if (directoryId !== geisingerHealthPlanDirectoryId) {
        parsedCarriers.push({
            id: CARRIER.BLUE_CROSS_BLUE_SHIELD,
            name: 'Blue Cross Blue Shield',
        });
    }

    return sortBy(parsedCarriers, ['name']);
}

function requestCarriersSucceeded(insuranceType, carriers) {
    return {
        type: REQUEST_CARRIERS_SUCCEEDED,
        payload: {
            insuranceType,
            carriers,
        },
    };
}

function requestCarriersFailed() {
    return {
        type: REQUEST_CARRIERS_FAILED,
    };
}

function fetchCarriers(insuranceType, directoryId) {
    return dispatch => {
        dispatch(requestCarriers(insuranceType));
        return fetch(url.format({
            protocol: apiUrl.protocol,
            host: apiUrl.host,
            pathname: '/api/1/carriers',
            query: {
                type: insuranceType,
                directoryType: directoryId === geisingerHealthPlanDirectoryId ? 'insurance,geisingerhealthplan' : null,
            },
        }), {
            credentials: 'same-origin',
        })
            .then(response => response.json())
            .then(json => {
                const carriers = parseCarriers(json.carriers, insuranceType, directoryId);
                dispatch(requestCarriersSucceeded(insuranceType, carriers));
            })
            .catch(() => dispatch(requestCarriersFailed()));
    };
}

function shouldFetchCarriers(state, insuranceType) {
    const carriers = carriersSelector(state, insuranceType);
    if (!carriers) {
        return true;
    }
    return false;
}

export function fetchCarriersIfNeeded(insuranceType, directoryId) {
    return (dispatch, getState) => {
        const state = getState();
        if (shouldFetchCarriers(state, insuranceType)) {
            return dispatch(fetchCarriers(insuranceType, directoryId));
        } else {
            const carriers = carriersSelector(state, insuranceType);
            if (carriers && carriers.length > 0) {
                dispatch(requestCarriersSucceeded(insuranceType, carriers));
            }
        }
    };
}
